export const websiteAddress = "https://allpaytr.com";
export const baseAPIAddress = process.env.REACT_APP_API_URL;
